/**
 * Validazione checksum della Partita IVA italiana (algoritmo Luhn modificato).
 *
 * Verifica SOLO che il formato sia matematicamente corretto, NON che la P.IVA
 * esista o sia attiva. Utile come fallback locale quando il servizio VIES e' down.
 *
 * Algoritmo:
 *  - 11 cifre
 *  - Cifre in posizione dispari (1,3,5,7,9): somma dirette
 *  - Cifre in posizione pari (2,4,6,8,10): raddoppia, se >9 sottrai 9, somma
 *  - 11esima cifra (controllo) = (10 - (somma % 10)) % 10
 */

export function validateItalianVatChecksum(piva: string | undefined | null): boolean {
  if (!piva) return false;
  const cleaned = piva.replace(/\D/g, '');
  if (cleaned.length !== 11) return false;

  let sum = 0;
  for (let i = 0; i < 10; i++) {
    let digit = parseInt(cleaned[i], 10);
    if (Number.isNaN(digit)) return false;
    if (i % 2 === 1) {
      // Posizione pari (1-indexed): raddoppia
      digit *= 2;
      if (digit > 9) digit -= 9;
    }
    sum += digit;
  }

  const expected = (10 - (sum % 10)) % 10;
  const actual = parseInt(cleaned[10], 10);
  if (Number.isNaN(actual)) return false;
  return expected === actual;
}
